import { render } from "./AttestationStage.vue?vue&type=template&id=4438f4a6&scoped=true"
import script from "./AttestationStage.vue?vue&type=script&lang=js"
export * from "./AttestationStage.vue?vue&type=script&lang=js"

import "./AttestationStage.vue?vue&type=style&index=0&id=4438f4a6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4438f4a6"]])

export default __exports__